<div>
    <app-header [background]="true" ></app-header>
    <app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>
    <section class="mainSection">
        <div class="container pb-5 pt-5">
            <div class="row">
                <div class="col-md-7">
                    <h1 class="mainTitle">Sobre o painel de Indicadores</h1>
                </div>
                <div class="col-md-5">
                    <img class="img-fluid" src="/assets/images/about/about.png" />
                </div>
            </div>
        </div>
    </section>
    <app-footer></app-footer>
</div>